import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { WebPageJsonLD, OrganizationJsonLD } from "@/components/feature/JsonLD";

const stats = [
  { number: "200+", label: "福利资源" },
  { number: "8", label: "分类维度" },
  { number: "50万+", label: "月访问量" },
  { number: "99.7%", label: "用户好评率" },
];

const testimonials = [
  {
    name: "张先生",
    role: "互联网从业者",
    content:
      "福利导航真的帮我省了不少钱！以前从来不知道有这么多优惠可以领，现在每个月至少能省下好几百块。特别是购物优惠板块，618的时候跟着攻略操作，省了将近1000块。",
    rating: 5,
  },
  {
    name: "李女士",
    role: "全职妈妈",
    content:
      "作为一个精打细算的全职妈妈，福利导航是我每天必逛的网站。生活补贴和积分兑换两个板块特别实用，家里的日常开销通过合理利用各种福利，一年下来真的省了不少。",
    rating: 5,
  },
  {
    name: "王同学",
    role: "在校大学生",
    content:
      "学生福利板块简直是宝藏！Apple教育优惠、B站大会员学生价、GitHub学生包，这些福利我之前完全不知道。感谢福利导航让我的大学生活质量提升了一个档次。",
    rating: 5,
  },
  {
    name: "赵经理",
    role: "企业人力资源总监",
    content:
      "作为HR，我经常需要了解市场上的员工福利政策。福利导航的职场福利板块信息全面且更新及时，已经成为我制定公司福利方案的重要参考来源。",
    rating: 5,
  },
];

const milestones = [
  { year: "2024年", event: "福利导航正式上线，首批覆盖4大福利分类" },
  { year: "2025年", event: "分类扩展至8个维度，月访问量突破20万" },
  { year: "2025年", event: "推出福利资讯订阅功能，订阅用户突破5万" },
  { year: "2026年", event: "月访问量突破50万，成为中文福利导航首选平台" },
];

export default function About() {
  return (
    <>
      <ScrollToTop />
      <OrganizationJsonLD />
      <WebPageJsonLD
        title="关于我们 - 福利导航"
        description="福利导航是一站式福利资源聚合平台，致力于为用户精准汇聚购物优惠、会员权益、生活补贴、职场福利等多维度福利信息。了解我们的品牌故事、用户口碑与联系方式。"
        url="https://fulidaohang.com/about"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-20">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>
        </div>

        {/* Brand Introduction Hero */}
        <section className="w-full px-4 md:px-6 py-14 md:py-20">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-5">
              关于福利导航
            </h1>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              福利导航诞生于2024年，是一站式福利资源聚合平台。在信息爆炸的时代，我们发现大量优质的福利资源散落在各个平台、APP和角落，用户往往因为信息不对称而错失了许多本该属于自己的权益和优惠。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
              因此，我们创建了福利导航——一个专注于福利信息聚合与分发的平台。我们的使命是<strong>让每一个人都能轻松发现并享受到属于自己的福利</strong>，不管你是精打细算的购物达人、精明的学生党，还是关注员工权益的职场人士，福利导航都能帮你找到最契合的福利资源。
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                  {stat.number}
                </div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Milestones */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-10 text-center">
              发展历程
            </h2>
            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>
              <div className="flex flex-col gap-8">
                {milestones.map((item, index) => (
                  <div
                    key={index}
                    className={`relative flex items-start gap-6 md:gap-0 ${
                      index % 2 === 0
                        ? "md:flex-row"
                        : "md:flex-row-reverse"
                    }`}
                  >
                    <div className="md:w-1/2 flex items-center pl-10 md:pl-0 md:justify-end md:pr-10">
                      <div
                        className={`text-left ${
                          index % 2 === 0 ? "md:text-right" : "md:text-left md:pl-10"
                        } ${index % 2 !== 0 ? "md:pr-0 md:pl-10" : ""}`}
                      >
                        <span className="text-xs text-primary-500 font-medium">
                          {item.year}
                        </span>
                        <p className="text-sm text-foreground-700 mt-1">{item.event}</p>
                      </div>
                    </div>
                    <div className="absolute left-4 md:left-1/2 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50 -translate-x-1/2 mt-1.5 z-10"></div>
                    <div className="md:w-1/2 hidden md:block"></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3 text-center">
              用户口碑
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-10 text-center">
              听听真实用户怎么说
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {testimonials.map((t, index) => (
                <div
                  key={index}
                  className="bg-background-50 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i
                        key={i}
                        className="ri-star-fill text-sm text-primary-400"
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    「{t.content}」
                  </p>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">
                      {t.name}
                    </p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="w-full px-4 md:px-6 py-14 md:py-18">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-heading text-xl md:text-3xl font-semibold text-foreground-900 mb-3 text-center">
              联系我们
            </h2>
            <p className="text-foreground-600 text-sm md:text-base mb-10 text-center">
              有任何问题或建议，欢迎随时联系我们
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-12">
              <div className="text-center p-5 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                  电子邮箱
                </h3>
                <p className="text-xs text-foreground-600">contact@fulidaohang.com</p>
              </div>
              <div className="text-center p-5 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-phone-line text-xl text-accent-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                  客服电话
                </h3>
                <p className="text-xs text-foreground-600">400-888-8888</p>
              </div>
              <div className="text-center p-5 rounded-lg border border-background-200/70">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-map-pin-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-1">
                  公司地址
                </h3>
                <p className="text-xs text-foreground-600">北京市朝阳区建国路88号</p>
              </div>
            </div>

            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9qmp4snlsngrm4lm290"
              method="POST"
              className="bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8"
            >
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-6">
                发送消息
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label
                    htmlFor="contact-name"
                    className="block text-sm text-foreground-700 mb-1.5"
                  >
                    姓名
                  </label>
                  <input
                    type="text"
                    id="contact-name"
                    name="name"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label
                    htmlFor="contact-email"
                    className="block text-sm text-foreground-700 mb-1.5"
                  >
                    邮箱
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    name="email"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label
                  htmlFor="contact-subject"
                  className="block text-sm text-foreground-700 mb-1.5"
                >
                  主题
                </label>
                <input
                  type="text"
                  id="contact-subject"
                  name="subject"
                  required
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  placeholder="请输入消息主题"
                />
              </div>
              <div className="mb-5">
                <label
                  htmlFor="contact-message"
                  className="block text-sm text-foreground-700 mb-1.5"
                >
                  消息内容
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={5}
                  required
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                  placeholder="请输入您的消息，最多500字"
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right">最多500字</p>
              </div>
              <button
                type="submit"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                发送消息
              </button>
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="contact-hp"
              />
            </form>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}